// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const randomizer = (probability: number = 0.5): number => (Math.random() < probability ? 1 : 0);
